/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createPinpad } from '../fn/admin-pinpads-api/create-pinpad';
import { CreatePinpad$Params } from '../fn/admin-pinpads-api/create-pinpad';
import { deletePinpad } from '../fn/admin-pinpads-api/delete-pinpad';
import { DeletePinpad$Params } from '../fn/admin-pinpads-api/delete-pinpad';
import { getAllPinpads } from '../fn/admin-pinpads-api/get-all-pinpads';
import { GetAllPinpads$Params } from '../fn/admin-pinpads-api/get-all-pinpads';
import { getPinpad } from '../fn/admin-pinpads-api/get-pinpad';
import { GetPinpad$Params } from '../fn/admin-pinpads-api/get-pinpad';
import { PageDtoPinpadPinpadDto } from '../models/page-dto-pinpad-pinpad-dto';
import { PinpadDto } from '../models/pinpad-dto';
import { resetPinpad } from '../fn/admin-pinpads-api/reset-pinpad';
import { ResetPinpad$Params } from '../fn/admin-pinpads-api/reset-pinpad';
import { updatePinpad } from '../fn/admin-pinpads-api/update-pinpad';
import { UpdatePinpad$Params } from '../fn/admin-pinpads-api/update-pinpad';

@Injectable({ providedIn: 'root' })
export class AdminPinpadsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPinpad()` */
  static readonly GetPinpadPath = '/api/admin/pinpads/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPinpad()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPinpad$Response(params: GetPinpad$Params, context?: HttpContext): Observable<StrictHttpResponse<PinpadDto>> {
    return getPinpad(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPinpad$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPinpad(params: GetPinpad$Params, context?: HttpContext): Observable<PinpadDto> {
    return this.getPinpad$Response(params, context).pipe(
      map((r: StrictHttpResponse<PinpadDto>): PinpadDto => r.body)
    );
  }

  /** Path part for operation `updatePinpad()` */
  static readonly UpdatePinpadPath = '/api/admin/pinpads/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePinpad()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePinpad$Response(params: UpdatePinpad$Params, context?: HttpContext): Observable<StrictHttpResponse<PinpadDto>> {
    return updatePinpad(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePinpad$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePinpad(params: UpdatePinpad$Params, context?: HttpContext): Observable<PinpadDto> {
    return this.updatePinpad$Response(params, context).pipe(
      map((r: StrictHttpResponse<PinpadDto>): PinpadDto => r.body)
    );
  }

  /** Path part for operation `deletePinpad()` */
  static readonly DeletePinpadPath = '/api/admin/pinpads/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePinpad()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePinpad$Response(params: DeletePinpad$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deletePinpad(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePinpad$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePinpad(params: DeletePinpad$Params, context?: HttpContext): Observable<void> {
    return this.deletePinpad$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAllPinpads()` */
  static readonly GetAllPinpadsPath = '/api/admin/pinpads';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllPinpads()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPinpads$Response(params?: GetAllPinpads$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoPinpadPinpadDto>> {
    return getAllPinpads(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllPinpads$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPinpads(params?: GetAllPinpads$Params, context?: HttpContext): Observable<PageDtoPinpadPinpadDto> {
    return this.getAllPinpads$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoPinpadPinpadDto>): PageDtoPinpadPinpadDto => r.body)
    );
  }

  /** Path part for operation `createPinpad()` */
  static readonly CreatePinpadPath = '/api/admin/pinpads';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPinpad()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPinpad$Response(params: CreatePinpad$Params, context?: HttpContext): Observable<StrictHttpResponse<PinpadDto>> {
    return createPinpad(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPinpad$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPinpad(params: CreatePinpad$Params, context?: HttpContext): Observable<PinpadDto> {
    return this.createPinpad$Response(params, context).pipe(
      map((r: StrictHttpResponse<PinpadDto>): PinpadDto => r.body)
    );
  }

  /** Path part for operation `resetPinpad()` */
  static readonly ResetPinpadPath = '/api/admin/pinpads/{id}/reset';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetPinpad()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetPinpad$Response(params: ResetPinpad$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return resetPinpad(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resetPinpad$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetPinpad(params: ResetPinpad$Params, context?: HttpContext): Observable<void> {
    return this.resetPinpad$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
